import classnames from "classnames";
import { makeStyles } from "components/providers/makeStyles";

const useStyles = makeStyles(theme => ({
    page: {
        padding: theme.spacing(3),
    }
}));
export const EmbeddedPage = ({ className, children }) => {
    const classes = useStyles();

    return (
        <main className={classnames(classes.page, className)}>
            {children}
        </main>
    );
};

